import { isClient, useLocalStorage } from '@vueuse/core'

import MaintenanceModalLayout from '~/components/layout/MaintenanceModalLayout.vue'
import MaintenanceModal from '~/components/modal/MaintenanceModal.vue'
import { MAINTENANCE_MODAL_CONFIG } from '~/constants/maintenance.const'

export const useMaintenanceModal = () => {
  const { dialog } = useGlobalDialog()
  
  // 하루 안보기 만료일을 저장
  const localStorageState = useLocalStorage('maintenance-modal-hidden', '')

  // 초기화 및 모달 표시 체크
  const initializeModal = () => {
    if (!isClient) return // 서버에서는 실행하지 않음
    if (!MAINTENANCE_MODAL_CONFIG.enabled) return // 모달이 비활성화되어 있으면 표시하지 않음
    
    // 하루 안보기 설정이 있는 경우 만료일 체크
    if (localStorageState.value) {
      const hiddenUntilDate = new Date(localStorageState.value)
      const now = new Date()
      
      // 아직 만료되지 않았으면 모달 표시하지 않음
      if (now < hiddenUntilDate) return
    }
    
    // 모든 조건을 통과하면 모달 표시
    dialog({
      component: MaintenanceModal,
      componentProps: {},
      layout: MaintenanceModalLayout
    })
  }
  
  // 내일까지 숨기기 (don't show again today 버튼용)
  const setHiddenUntilTomorrow = async () => {
    if (!isClient) return

    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    tomorrow.setHours(0, 0, 0, 0) // 내일 자정
    
    const isoString = tomorrow.toISOString()
    
    // useLocalStorage의 value에 할당
    localStorageState.value = isoString
    
    // nextTick을 사용하여 DOM 업데이트가 완료될 때까지 대기
    await nextTick()
  }

  return {
    setHiddenUntilTomorrow,
    initializeModal,
  }
}
